/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Row_LastInputs */

const en_us2_swap_row_last = /** @type {(inputs: Swap_Row_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last time`)
};

const pt_br2_swap_row_last = /** @type {(inputs: Swap_Row_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última vez`)
};

const es_419_swap_row_last = /** @type {(inputs: Swap_Row_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última vez`)
};

const pt_pt2_swap_row_last = /** @type {(inputs: Swap_Row_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última vez`)
};

const fr_fr2_swap_row_last = /** @type {(inputs: Swap_Row_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière fois`)
};

const de_de2_swap_row_last = /** @type {(inputs: Swap_Row_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letztes Mal`)
};

const it_it2_swap_row_last = /** @type {(inputs: Swap_Row_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima volta`)
};

/**
* | output |
* | --- |
* | "Last time" |
*
* @param {Swap_Row_LastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_row_last = /** @type {((inputs?: Swap_Row_LastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Row_LastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_row_last(inputs)
	if (locale === "es-419") return es_419_swap_row_last(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_row_last(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_row_last(inputs)
	if (locale === "de-DE") return de_de2_swap_row_last(inputs)
	if (locale === "it-IT") return it_it2_swap_row_last(inputs)
	return en_us2_swap_row_last(inputs)
});
export { swap_row_last as "swap.row_last" }